/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartTrendXyUpIcon20Light = forwardRef('DataChartTrendXyUpIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3 3.5a.5.5 0 0 0-1 0v12A2.5 2.5 0 0 0 4.5 18h14a.5.5 0 0 0 0-1h-14A1.5 1.5 0 0 1 3 15.5v-12Z" }),
        React.createElement("path", { d: "M18.287 6.291a.5.5 0 1 0-.707-.707l-5.536 5.536-2.568-2.567a.89.89 0 0 0-1.26 0L4.96 11.81a.5.5 0 1 0 .707.707l3.18-3.18 2.568 2.568a.89.89 0 0 0 1.26 0l5.613-5.614Z" })));
});
